// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"72b1cf2b","879":"4a6ab98e"}[chunkId] + ".chunk.js";
};